@if (this.costDetails) {
<form [formGroup]="editPercentageForm">
  <h5>Risico percentage</h5>
  <div class="col-md-6">
    <div class="input-group mb-4">
      <input
        type="number"
        class="form-control"
        formControlName="risk"
        id="riskpercentageInput"
      />
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon1">% </span>
      </div>
    </div>
  </div>
  <h5>Winst percentage</h5>
  <div class="col-md-6">
    <div class="input-group mb-4">
      <input
        type="number"
        class="form-control"
        formControlName="profit"
        id="profitpercentageInput"
      />
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon1">% </span>
      </div>
    </div>
  </div>
</form>
}
